/* accordion */
$(function() {
    $('.accordionItem').each(function(i, accordion) {
        const accordionTrigger = '.accordionTrigger';
        const accordionContent = '.accordionContentArea';
        const findAccordionTrigger = $(this).find(accordionTrigger);
        const findAccordionContent = $(this).find(accordionContent);

        // Apply ARIA and display values on load
        if (findAccordionTrigger.hasClass('__active')) {
            findAccordionTrigger.attr('aria-expanded', true);
            findAccordionContent.show();
            findAccordionContent.attr('aria-hidden', false);
        } else {
            findAccordionTrigger.attr('aria-expanded', false);
            findAccordionContent.hide();
            findAccordionContent.attr('aria-hidden', true);
        }

        // On click of accordion trigger
        findAccordionTrigger.click(function(e) {
            e.preventDefault();
            /* close an open accordion */
            if ($(this).hasClass('__active')) {
                $(this).attr('aria-expanded', false);
                $(this).removeClass('__active');
                findAccordionContent.slideUp();
                findAccordionContent.attr('aria-hidden', true);
            } /* open a closed accordion and close open siblings without the AccordionManualClose class*/ else {
                $(this).attr('aria-expanded', true);
                $(this).parents('.accordionItem').not('.AccordionManualClose').siblings().children('.accordionTrigger').attr('aria-expanded', false);
                $(this).addClass('__active');
                $(this).parents('.accordionItem').not('.AccordionManualClose').siblings().children('.accordionTrigger').removeClass('__active');
                findAccordionContent.slideDown();
                $(this).parents('.accordionItem').not('.AccordionManualClose').siblings().children('.accordionContentArea').slideUp();
                findAccordionContent.attr('aria-hidden', false);
                $(this).parents('.accordionItem').not('.AccordionManualClose').siblings().children('.accordionContentArea').attr('aria-hidden', true);
            }
        });
    });
});

